export enum ReportTypeEnums {
    DepositoryInitialReport = 10,
    DepositoryYearEndReport = 11,
    DissolutionReport = 12,
    ExternalActivityReport = 13,
    TransitionOutReport = 14,
    TrainsitionInReport = 15,
    IEPACYearEndReport = 36,
    IEPACDissolutionReport = 37,
    BallotQuestionInitialReport = 40,
    BallotQuestion60thDayReport = 41,
    BallotQuestionSep20Report = 42,
    BallotQuestionOct5Report = 43,
    BallotQuestionOct20Report = 44,
    BallotQuestionYearEnd = 45,
    BallotQuestionDissolutionReport = 46,
    BallotQuestionNov5Report = 48,
    BallotQuestionNov20Report = 49,
    LpcPrePrimary = 50,
    LpcPreElection = 51,
    LpcYearEnd = 52,
    DepositReport = 60,
    LateContributionReport = 61,
    DonationReport = 62,
    SubvendorReport = 63,
    IEPACReport = 64,
    PayrollItemizationReport = 65,
    BankExpenditureItemizationReport = 66,
    BankReport = 70,
    BankReportFirstHalf = 71,
    BankReportSecondHalf = 72,
    CreditCardReport = 80,
    ReimbursementReport = 90,
    MunPrePrimaryReport = 110,
    MunPreElectionReport = 111,
    MunYearEndReport = 113,
    IndependentExpendituresReport = 'IE',
    IEReport = '200',
    ElectioneeringCommunicationsReport = 'EC',
    ECReport = '202',
    IndependentBallotQuestionSpending = 'BQS',
    Cpf22sReport = '203',
    PoliticalSpendingReport = 'PSR'
};
